import { AmountType, SIGN } from "../@types/common";
import { BREAKPOINTS } from "../constants/common";
import { useWindowSize } from "../hooks/useWindowWidth";
import Tooltip from "./tooltip";
interface InfoItemProps {
  title: string;
  description: string;
  amount: AmountType;
}
const InfoItem = ({ title, description, amount }: InfoItemProps) => {
  const windowWidth = useWindowSize();
  const { EXTRA_LARGE } = BREAKPOINTS;
  return (
    <div
      className={`infoItem border-r-2 border-darkBlue ${
        windowWidth < EXTRA_LARGE ? "mb-5" : "mb-8"
      }`}
    >
      <div className="pr-3">
        <span
          className={`text-darkBlue ${
            windowWidth < EXTRA_LARGE
              ? "text-[16px] flex justify-between items-center"
              : "text-[22px] inline-block align-middle"
          }`}
        >
          {title}
          <span className="pr-2">
            <Tooltip title={title} message={description} />
          </span>
        </span>
      </div>
      <span
        className={`text-blue pr-3 inline-block pl-1 ${
          windowWidth < EXTRA_LARGE ? "text-[20px]" : "text-[26px]"
        }`}
      >
        {
          amount.sign === SIGN.ILS
            ? `${amount.value} ${amount.sign}` // ILS
            : `${amount.value}${amount.sign}` // PERCENT
        }
      </span>
    </div>
  );
};
export default InfoItem;